import { Circle, Fill, Stroke, Style } from 'ol/style';
import Config from '@vendor/js/config';
export default (feature, resolution) => {
    return new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new Stroke({
            color: Config.colors.primary,
            width: 3,
        }),
        image: new Circle({
            radius: 5,
            fill: new Fill({
                color: Config.colors.primary,
            }),
            stroke: new Stroke({
                color: 'white',
            }),
        }),
    });
};
